import { render, staticRenderFns } from "./WebDesignSection.vue?vue&type=template&id=13107cff&scoped=true"
import script from "./WebDesignSection.vue?vue&type=script&lang=js"
export * from "./WebDesignSection.vue?vue&type=script&lang=js"
import style0 from "./WebDesignSection.vue?vue&type=style&index=0&id=13107cff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13107cff",
  null
  
)

export default component.exports